import { useLocation, Link } from "react-router-dom";
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="relative flex flex-col items-center justify-center flex-1 text-center px-4 py-32 md:py-40">
        <h1 className="absolute bottom-0 text-7xl sm:text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10 flex flex-col items-center">
          <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mb-6">
            <i className="ri-error-warning-line text-primary-500 text-3xl"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-display font-bold text-foreground-950">
            Страница не найдена
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            Запрошенная страница не существует или была удалена.
          </p>
          <Link
            to="/"
            className="mt-6 h-11 px-6 inline-flex items-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Вернуться на главную
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}